export default function StoryText({ htmlContent }) {
  return (
    <div className="w-full ">
      <div
        dangerouslySetInnerHTML={{ __html: htmlContent }}
        className="w-full container mx-auto px-[20px] py-[30px] lg:px-[80px] leading-8 "
      />
    </div>
  );
}
